export default __webpack_public_path__ + "static/media/step_analysis.ac3207ca.png";